export const categories = [
  {
    id: "11",
    title: "HTML",
    description:
      "Take this quiz to test your HTML skills, each set contains 5 questions having points according to the level you've chosen.",
    image: "assets/images/HTML.jpg",
    category_type: "FEATURED",
    tags: ["HTML"],
    timer_detail: [
      { level: "EASY", time: 30 },
      { level: "MED", time: 60 },
      { level: "HARD", time: 90 },
    ],
  },
  {
    id: "12",
    title: "CSS",
    description:
      "Take this quiz to test your CSS skills, each set contains 5 questions having points according to the level you've chosen.",
    image: "assets/images/CSS.jpg",
    category_type: "FEATURED",
    tags: ["CSS"],
    timer_detail: [
      { level: "EASY", time: 30 },
      { level: "MED", time: 70 },
      { level: "HARD", time: 90 },
    ],
  },
  {
    id: "13",
    title: "JS",
    description:
      "Take this quiz to test your JS skills, each set contains 5 questions having points according to the level you've chosen.",
    image: "assets/images/JS.jpg",
    category_type: "FEATURED",
    tags: ["JS"],
    timer_detail: [
      { level: "EASY", time: 30 },
      { level: "MED", time: 70 },
      { level: "HARD", time: 90 },
    ],
  },
];
